var _desc, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgModule2Icon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M12,22.6C6.2,22.6,1.4,17.8,1.4,12S6.2,1.4,12,1.4 S22.6,6.2,22.6,12S17.8,22.6,12,22.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.2,10.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S9.6,10.5,8.2,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8,10.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5S17.2,10.5,15.8,10.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.4,12.6c0-0.6,0.2-1.1,0.6-1.5c-0.4,0.1-0.8,0.2-1.2,0.2c-1,0-1.9-0.5-2.5-1.2h-2.5c1,0.8,1.7,2,1.7,3.4v4.5h4.2 v-2.3c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v2.3h1.2c0.2,0,0.4-0.2,0.4-0.4v-2.9h-0.6C17.4,14.7,16.4,13.8,16.4,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2,14.7L19.2,14.7L19.2,14.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.1,13.8h-0.5c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2c0.5,0,1,0.4,1,1v1.1C19.5,13.6,19.3,13.8,19.1,13.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1,10.7c-0.5,0.4-1.2,0.6-1.9,0.6c-0.4,0-0.8-0.1-1.2-0.2c0.4,0.4,0.6,0.9,0.6,1.5c0,1.2-1,2.1-2.1,2.1H4.8v2.9 c0,0.2,0.2,0.4,0.4,0.4h1.2v-2.3c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v2.3h4.2v-4.5C11.6,12.4,11,11.4,10.1,10.7 L10.1,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8,14.7L4.8,14.7L4.8,14.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,13.4v-1.1c0-0.5,0.4-1,1-1c0.7,0,1.2,0.6,1.2,1.2s-0.6,1.2-1.2,1.2H4.9C4.7,13.8,4.5,13.6,4.5,13.4z"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgModule2Icon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/module2icon.c386e65e.svg";
export { ForwardRef as ReactComponent };